import * as Yup from 'yup'

export const emrCodeSchema = Yup.object({
  active: Yup.number().required(),
  code: Yup.string().required(),
  code_text: Yup.string().nullable().optional(),
  code_text_short: Yup.string().nullable().optional(),
  code_type: Yup.string().required(),
  id: Yup.number().required(),
})

export const validationSchema = Yup.object({
  cpt4_code: emrCodeSchema.required('Product is required').nullable(),
  icd10_codes: Yup.array().of(emrCodeSchema),
  procedure_units: Yup.string().nullable().optional(),
  units: Yup.number()
    .typeError('Units must be a number')
    .positive()
    .integer()
    .required('Units is required'),
  price: Yup.number()
    .typeError('Price must be a number')
    .positive()
    .min(0, 'Price must be greater than or equal to 0')
    .required('Price is required'),
  upc: Yup.string().trim().optional(),
  discount_type_id: Yup.string().nullable().optional(),
})

export type FormValues = Yup.InferType<typeof validationSchema>
